import { useEffect, useState } from "react";
import useTalentApi from "components/Screens/Marketplace/Customer/TalentApiContext";
import { toolLogos } from "components/Screens/Marketplace/Customer/utils/tools";
import type { TalentApi } from "components/Screens/Marketplace/Customer/TalentApiContext";

// One catalogue request per tools endpoint (portal or PLG) for the tab; a failed one is asked again next time.
const loads = new WeakMap<TalentApi["fetchTools"], Promise<Map<string, string>>>();

function loadOnce(fetchTools: TalentApi["fetchTools"]): Promise<Map<string, string>> {
  let load = loads.get(fetchTools);
  if (!load) {
    load = fetchTools()
      .then((tools) => toolLogos(tools || []))
      .catch(() => {
        loads.delete(fetchTools);
        return new Map<string, string>();
      });
    loads.set(fetchTools, load);
  }
  return load;
}

/** Each tool's logo by toolKey (marketplace tools.logoUrl), for the tool pills on cards; empty until loaded. */
export default function useToolLogos(): Map<string, string> {
  const { fetchTools } = useTalentApi();
  const [logos, setLogos] = useState<Map<string, string>>(() => new Map());
  useEffect(() => {
    if (!fetchTools) return undefined;
    let live = true;
    loadOnce(fetchTools).then((m) => live && setLogos(m));
    return () => {
      live = false;
    };
  }, [fetchTools]);
  return logos;
}
